import React, { FC } from 'react'
import { authHelper } from '@entities/user'
import { Button } from '@shared/ui/molecules'
import { useBreakpoint } from '@shared/lib/react'

const LogoutButton: FC = () => {
  const { isMobile } = useBreakpoint()

  return (
    <Button size="44" variant={isMobile ? 'tertiary' : 'secondary'} onClick={authHelper.logOut}>
      Выйти
    </Button>
  )
}

export default LogoutButton
